import React, { useEffect, useState } from 'react'
import ModalDiligenciarRecordAnestesia from './ModalDiligenciarRecordAnestesia'
import { postProcedimientoDetalles, postProcedimientoModificar } from '../../../services/PaginaRuta'

const ModalProcedimientosRecordAnestesia = ({setmodalOnProcedimientosQx,dataUserDiligenciar}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const [modalOnDiligenciarRecordAnestesia, setmodalOnDiligenciarRecordAnestesia]=useState(false)
    const [dataProcedimientos,setdataProcedimientos]=useState([])
    const handleOnclicDiligenciar=()=>{
        setmodalOnDiligenciarRecordAnestesia(true)
    }
    const handleCancelarClick=()=>{
        setmodalOnProcedimientosQx(false)
    }
    const data = [
        { nombre: ' REMOCION DE RIÑON TRANSPLANTADO O RECHAZADO VIA ABIERTA', codigoCirugia: '123' },
        // ... otros registros
      ];
    useEffect(()=>{
      const body = {
        vaProEmpCod:  usuarioInfo.Empresa,
        varProMCDpto: usuarioInfo.Sede,
        varProCirCod: dataUserDiligenciar.ProCirCod,
      };
      // postProcedimientoModificar(body).then((res)=>{
      //   console.log(res.data,'data procedimientos')
      // })
      postProcedimientoDetalles(body).then((res)=>{
        console.log(res.data,'data procedimientos')
        setdataProcedimientos(res.data)
      })
    },[])
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-2xl my-6 mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Procedimientos quirúrgico 
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-2 ">
            <div className="flex py-2 text-left">
            </div>
              
              <div className="flex flex-col">
          <div className="overflow-x-auto  ">
            <div className="py-4 inline-block min-w-full">
              <div className="overflow-hidden">
                <table className="min-w-full text-center bg-gray-200">
                  <thead className=" ">
                    <tr>                     
                      
                      <th></th>
                      
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Codigo Procedimiento
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Nombre Procedimiento 
                      </th>
                      
                      
                    </tr>
                  </thead>
                  <tbody>
                    {
                      dataProcedimientos.map((item,index)=>(
                        <tr key={index} className=" divide-y divide-slate-700 ">
                        <td></td>
                        
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
                        {item.CrgCod}
                        
                        </td>
                        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
                        {item.CrgDes}
                        
                        </td>
                    </tr>
                      ))
                    }
                    
                    
                    </tbody>
                  
                </table>
              </div>
            </div>
          </div>
        </div>
            
          </div>
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-3 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            <button
              type="button"
              onClick={handleOnclicDiligenciar}
              className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
              Diligenciar
            </button>
          </div>
        </div>
      </div>
      {modalOnDiligenciarRecordAnestesia? <ModalDiligenciarRecordAnestesia setmodalOnDiligenciarRecordAnestesia={setmodalOnDiligenciarRecordAnestesia} dataUserDiligenciar={dataUserDiligenciar}/>:null}
    </div>
  )
}

export default ModalProcedimientosRecordAnestesia